import React from 'react';
import { ThunderboltFilled } from '@ant-design/icons';
import styles from './setup-banner.module.scss';

export const SetupBanner = () => {
  return (
    <div className={styles.setupBanner}>
      <div className={styles.headerContainer}>
        <ThunderboltFilled className={styles.setupIcon} />
        <div className={styles.setupTitle}>Complete Your Setup</div>
      </div>
      <div className={styles.setupDescription}>
        Configure your queue settings to start distributing leads to your team members.
      </div>
    </div>
  );
};
